<template>
    <!-- <div> -->
          
       
<el-button @click="packdownload" type="primary" :disabled="disabledDownload"   size="small"
           icon="el-icon-download">打包下载</el-button>
        <!-- </div> -->
</template>

<script>
import * as api from "@/api/text/textothen";
import { downLoadTemplate } from "@/router/downLoadTem";
export default {
data(){
    return {

    }
},
props:{
    packdownid:String,
    projectname:String,
    disabledDownload:Boolean
},
methods:{
    packdownload(){
        downLoadTemplate("/api/file/downAll", {
          id: this.packdownid ,
          downName:this.projectname
        }).finally(() => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "已下载"
          });
        });
    }
}
}
</script>

<style>

</style>